import { Badge, Breadcrumbs, Button, Skeleton, Stack, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import HomeIcon from '@mui/icons-material/Home';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import WidgetsIcon from '@mui/icons-material/Widgets';
import { useNavigate } from 'react-router-dom';


function DeployerPage() {
    const navigate = useNavigate();
    // const [aaList, setAAList] = useState([{ "_id": "67c96bb61ecefbb3d06b3bfb", "aa_id": "e18dfda2-0f68-4756-9ed6-059a900b4e3e", "aa_name": "Authorization Service 1", "aa_url": "http://localhost:6000", "status": "online", "last_heartbeat": "2025-03-18T06:36:51.119Z" }, { "_id": "67c96bde1ecefbb3d06b3bfc", "aa_id": "f47e1cf4-6d7f-44e4-b431-9005cf027f84", "aa_name": "Authorization Service 2", "aa_url": "http://localhost:6001", "status": "offline", "last_heartbeat": "2025-03-06T09:35:48.133Z" }])
    const [aaList, setAAList] = useState([])
    const [loading, setLoading] = useState(false)


    useEffect(() => {
        const fetchAA = async () => {
            setLoading(true)
            try {
                const resp = await fetch(`${process.env.REACT_APP_AA_DISCOVERY}/services`);
                if (!resp.ok) throw new Error(`HTTP error! Status: ${resp.status}`);
                const aa = await resp.json();
                setAAList(aa)
                setLoading(false)
            } catch (error) {
                setLoading(false)
                console.log(error)
            }
        }
        localStorage.removeItem("aa-selected")
        fetchAA();
    }, [])

    const handleOnSelectAA = (aa) => {
        localStorage.setItem("aa-selected", JSON.stringify(aa))
        navigate('/deployer/workspace');
    }


    return (
        <section className="overflow-auto w-full bg-gradient-to-r from-green-50 via-blue-50 to-blue-100">
            <div className='mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 overflow-hidden w-full'>
                <div className='pt-10'>
                    <div role='presentation'>
                        <Breadcrumbs aria-label="breadcrumb">
                            <Typography sx={{ color: 'text.primary', display: 'flex', alignItems: 'center' }} variant='h6'>
                                <HomeIcon sx={{ mr: 0.5 }} fontSize="inherit" />
                                Policy Deployer
                            </Typography>
                        </Breadcrumbs>
                    </div>
                </div>
                <div className='animate-fade-right'>
                    <div className='grid gap-1 mt-8'>
                        <div className='flex justify-between bg-white rounded-t-md h-24 p-4 border border-gray-200'>
                            <div className='h-full content-evenly'>
                                <Typography variant='inherit'>Choose IAAM-Attribute Based Authorization (AA)</Typography>
                            </div>
                        </div>
                        {loading ? (
                            <Skeleton variant="rectangular" animation="wave" width={"100%"} height={80} className='rounded-b-md' />
                        )
                            : aaList.length > 0 ?
                                aaList.map((aa, idx) =>
                                    <div key={idx} onClick={aa.status === "online" ? () => handleOnSelectAA(aa) : undefined} className={`flex justify-between bg-white h-20 p-4 border border-gray-200 hover:bg-neutral-50 cursor-pointer ${idx === aaList.length - 1 ? 'rounded-b-md' : ''}`}>
                                        <Stack direction="row" spacing={2}>
                                            <div className='h-full content-evenly'>
                                                <Badge
                                                    variant="dot"
                                                    anchorOrigin={{
                                                        vertical: 'bottom',
                                                        horizontal: 'right',
                                                    }}
                                                    color={`${aa.status === "online" ? "success" : "error"}`}
                                                >
                                                    <WidgetsIcon color='primary' />
                                                </Badge>
                                            </div>
                                            <div className='h-full content-evenly'>
                                                <Typography variant='body1'>{aa.name}</Typography>
                                                <Typography variant='subtitle2' color='textSecondary'>{aa.aa_url}</Typography>
                                            </div>
                                        </Stack>
                                        <div className='h-full content-evenly'>
                                            <NavigateNextIcon color={`${aa.status === "online" ? 'primary' : 'disabled'}`} fontSize="small" />
                                        </div>
                                    </div>
                                )
                                : (
                                    <div className='flex items-center justify-center w-full h-[80px] bg-gray-500 bg-opacity-20 rounded-b-md' >
                                        <Typography color='textSecondary'>AA not available.</Typography>
                                    </div>
                                )

                        }
                    </div>
                </div>
            </div>
        </section>

    )
}

export default DeployerPage